import { render, staticRenderFns } from "./ParlamentarVotosItemList.vue?vue&type=template&id=1252f684&scoped=true&"
import script from "./ParlamentarVotosItemList.vue?vue&type=script&lang=js&"
export * from "./ParlamentarVotosItemList.vue?vue&type=script&lang=js&"
import style0 from "./ParlamentarVotosItemList.vue?vue&type=style&index=0&id=1252f684&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252f684",
  null
  
)

export default component.exports